module.exports = __webpack_public_path__ + "static/amp-banner-85b4b39d3a7e1f7d049bd8ea41bf2759.png";